import { useEffect, useState } from "react";
import { PacmanLoader } from "react-spinners";
import { LoaderSizeMarginProps } from "react-spinners/helpers/props";

const Pacman = (props: LoaderSizeMarginProps) => {
    const [LoadingColor, setLoadingColor] = useState("#F39C12");

    useEffect(() => {
        setLoadingColor(getComputedStyle(document.body).getPropertyValue("--kt-primary"));
    }, []);

    return <PacmanLoader color={LoadingColor} {...props} />;
};

export default Pacman;
